module.exports = __webpack_public_path__ + "img/rouler_positions_4.85674ea7.png";